import { render, staticRenderFns } from "./backtoschool.vue?vue&type=template&id=2093d0f6&scoped=true"
import script from "./backtoschool.vue?vue&type=script&lang=js"
export * from "./backtoschool.vue?vue&type=script&lang=js"
import style0 from "./backtoschool.vue?vue&type=style&index=0&id=2093d0f6&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2093d0f6",
  null
  
)

export default component.exports